import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import GlobalTable from '../components/GlobalTable';
import { useLazyTable } from '../hooks/useLazyTable';
import axiosInstance from '../services/axiosInstance';
import { handleApiError } from '../components/apiErrorHandler';
import { useBreadcrumbs } from '../contexts/BreadcrumbContext';

const CreditNotes = () => {
  const [notes, setNotes] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { lazyParams, onPage, onSort, onFilter, queryParams } = useLazyTable({ rows: 15 });
  const [loading, setLoading] = useState(false);
  const { push, beginDrilldown } = useBreadcrumbs();
  const navigate = useNavigate();

  const loadNotes = () => {
    setLoading(true);
    axiosInstance.get('/api/credit-notes/', { params: queryParams })
      .then(res => {
        setNotes(res.data.results || []);
        setTotalRecords(res.data.count || 0);
      })
      .catch(handleApiError)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadNotes();
  }, [queryParams]);

  const columns = [
    { Header: 'Credit Note #', accessor: 'id', filtered: true },
    { Header: 'Invoice #', accessor: 'invoice_number', filtered: true,
      bodyTemplate: (rowData) => (
        <span
          style={{ color: '#2563eb', cursor: 'pointer' }}
          onClick={() => {
            beginDrilldown();
            navigate('/invoices', {
              state: { invId: rowData.invoice }
            });
            push({
              label: 'Credit Notes',
              path: '/credit-notes'
            });
            push({
              label: `Invoices`,
              path: '/invoices',
            });
            push({
              label: `Invoice: ${rowData.invoice_number}`,
              path: '/invoices',
              state: { invId: rowData.invoice }
            });
          }}
        >
          {rowData.invoice_number}
        </span>
      )
     },
    { Header: 'Customer', accessor: 'customer_name', filtered: true,
      bodyTemplate: (rowData) => (
        <span
          style={{ color: '#2563eb', cursor: 'pointer' }}
          onClick={() => {
            beginDrilldown();
            navigate(`/customers/${rowData.customer_id}`)
            push({
              label: 'Credit Notes',
              path: '/credit-notes'
            });
            push({
              label: `Customer: ${rowData.customer_name}`,
              path: `/customers/${rowData.customer_id}`,
            });
          }}
        >
          {rowData.customer_name}
        </span>
      )
     },
    { Header: 'Reason', accessor: 'reason'},
    { Header: 'Date', accessor: 'created_at', dataType: 'date' },
  ];

  return (
    <div className="containers">
      <GlobalTable
        columns={columns}
        data={notes}
        loading={loading}
        tabletitle="Credit Notes"
        showEditColumn={false}
        lazy
        totalRecords={totalRecords}
        lazyParams={lazyParams}
        onPage={onPage}
        onSort={onSort}
        onFilter={onFilter}
        headerAction={
          <Button icon="pi pi-refresh" label="Refresh" outlined onClick={loadNotes} />
        }
      />
    </div>
  );
};

export default CreditNotes;
